import get from "lodash/get";
import { array, object, string } from "prop-types";
import React from "react";
import Row from "./Row";

import "./multipurposeComponent.m.css";

const MultipurposeComponent = ({ collection }) => {
  const isOneColumn = get(collection, ["associated-metadata", "is_one_column"], false);

  const columnColor0 = get(collection, ["associated-metadata", "first_column_color"], "");
  const columnColor1 = get(collection, ["associated-metadata", "second_column_color"], "");
  const columnColor2 = get(collection, ["associated-metadata", "third_column_color"], "");
  const columnColor3 = get(collection, ["associated-metadata", "fourth_column_color"], "");
  const showSubHeading = get(collection, ["associated-metadata", "show_sub_heading_in_website"], true);

  const subCollections = collection.items.filter((item) => item.type === "collection").slice(0, 4);
  const wrapperClass = isOneColumn
    ? "oneColumn"
    : subCollections.length === 2
    ? "columnTwo"
    : subCollections.length === 3
    ? "restColumn columnThree"
    : "restColumn";

  return (
    <div styleName="base">
      <div styleName={`wrapper ${wrapperClass}`}>
        {!isOneColumn &&
          subCollections &&
          subCollections.map((collection, index) => (
            <Row
              key={index}
              numberOfStories={4}
              colNumber={index}
              collection={collection}
              totalCollection={subCollections.length}
              showSubHeading={showSubHeading}
              columnColor0={columnColor0}
              columnColor1={columnColor1}
              columnColor2={columnColor2}
              columnColor3={columnColor3}
            />
          ))}

        {isOneColumn && (
          <Row
            numberOfStories={10}
            colNumber={0}
            collection={collection}
            showSubHeading={showSubHeading}
            columnColor0={columnColor0}
          />
        )}
      </div>
    </div>
  );
};

MultipurposeComponent.nestedCollectionLimit = [4, 4, 4, 4];
MultipurposeComponent.storyLimit = 10;

MultipurposeComponent.propTypes = {
  collection: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

export default MultipurposeComponent;
